import { encode } from 'html-entities';
import { isArray } from 'lodash-es';

/**
 Matches a URL using either a RegExp or a simple string includes
 */
export const matchesRoute = (match: RegExp | string, url: string) => {
  if (match instanceof RegExp) {
    return match.test(url);
  }

  return url.includes(match);
};

/**
 Supports reading a nested value
 */
export const getValueByPath = (obj: any, path: string) => path.split('.').reduce((acc, key) => acc?.[key], obj);

/**
 Supports writing a nested value
 */
export const setValueByPath = (obj: any, path: string, value: any) => {
  const keys = path.split('.');
  const last = keys.pop()!;
  const target = keys.reduce((acc, key) => {
    if (acc[key] === null || acc[key] === undefined) {
      acc[key] = {};
    }
    return acc[key];
  }, obj);
  target[last] = value;
};

/**
 * Returns true if the string appears to already be HTML-encoded
 */
export const isHtmlEncoded = (value: string) => encode(value) === value;

/**
 * Applies a string transform to an array field using `[]` notation (e.g. 'ownershipGroups[].name').
 *
 * @param obj Source object to modify
 * @param path Field path with array notation
 * @param transform Function applied to each string value
 * @param skipIfEncoded Skips transforming values already HTML-encoded
 */
export const applyTransformToArrayField = (
  obj: any,
  path: string,
  transform: (value: string) => string,
  skipIfEncoded?: boolean,
) => {
  const [arrayPart, field] = path.split('[].');

  const arr = getValueByPath(obj, arrayPart);
  if (!isArray(arr)) return false;

  arr.forEach((item) => {
    const value = getValueByPath(item, field);
    if (typeof value !== 'string') return;
    if (skipIfEncoded && isHtmlEncoded(value)) return;

    setValueByPath(item, field, transform(value));
  });

  return true;
};
